//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import goodList from '@/components/activityProduct/index.vue';
export default {
  name: 'GoodListFrom',
  components: {
    goodList: goodList
  },
  data: function data() {
    return {
      handleNum: '',
      visible: false,
      callback: function callback() {},
      checked: [],
      activityId: null,
      marketingType: null
    };
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getStoreItem: function getStoreItem(img) {
      this.callback(img);
      this.visible = false;
    }
  }
};